import React, { useState, useEffect, useRef } from 'react';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import LateralMenuList from './LateralMenuList';
import { Link, Navigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import session from '../../../SessionHandler/session-helper';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { removeUser } from '../../../actions';
import SimpleModal from '../Modal/SimpleModal';
import SettingsIcon from '@mui/icons-material/Settings';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import Box from '@mui/material/Box';
import { persistor } from '../../../configureStore';
import { changeARAluno, currentUser, changePhoto } from '../../../components/Usuario/api-usuario';
import { getQuantNaoLidas } from '../../../components/Mensagem/SalaParticipante/api-sala-participante';
import BadgeQuantNaoLidas from '../../../components/Mensagem/MensagemTable/BadgeQuantNaoLidas';
import { setQuantNaoLidas } from '../../../components/Mensagem/SalaParticipante/actions/actions';
import { setUsuario } from '../../../components/Usuario/actions/actions';
import { ADMIN, COORDENADOR, RESPONSAVEL } from '../../../components/Usuario/Perfil';
// import { setQuantAprovacaoComunicado } from '../../../components/Comunicado/Comunicado/actions/actions';
// import { getQuantAprovacaoComunicado } from '../../../components/Comunicado/Comunicado/api-comunicado';
// import { setQuantAprovacaoEvento } from '../../../components/Evento/Evento/actions/actions';
// import { getQuantAprovacaoEvento } from '../../../components/Evento/Evento/api-evento';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { findByUsuario } from '../../../components/AlunoResponsavel/api-aluno-responsavel';
import { toast } from 'react-toastify';
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        variants: [
            {
                props: ({ open }) => open,
                style: {
                    transition: theme.transitions.create('margin', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    marginLeft: 0,
                },
            },
        ],
    }),
);

const Spacer = styled('div')({
    flexGrow: 1,
});


const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                width: `calc(100% - ${drawerWidth}px)`,
                marginLeft: `${drawerWidth}px`,
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export default function LateralMenuSkeleton(props) {
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const [redirect, setRedirect] = useState(false);
    const { children } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElAR, setAnchorElAR] = React.useState(null);
    const isLogout = useSelector(state => state.logout);
    const dispatch = useDispatch();
    const quantNaoLidas = useSelector(state => state.quantNaoLidas);
    const quantAprovacaoComunicado = useSelector(state => state.quantAprovacaoComunicado);
    const quantAprovacaoEvento = useSelector(state => state.quantAprovacaoEvento);
    const [listaAR, setListaAR] = useState([]);
    const hiddenFileInput = useRef(null);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const usuario = useSelector(state => state.usuario);
    const [modal, setModal] = useState({
        open: false,
        title: '',
        description: ''
    })

    useEffect(() => {
        if (usuario &&
            usuario.perfil === RESPONSAVEL) {

            findByUsuario(usuario.id).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.message);
                    } else {
                        setListaAR(data);
                    }
                }
            });
        }
    }, [usuario]);

    useEffect(() => {
        if (!usuario) {
            currentUser().then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.message);

                    } else {
                        dispatch(setUsuario(data));
                    }
                }

            })
        }

        getQuantNaoLidas().then((data) => {
            if (data) {
                if (data.error) {
                    console.log(data.message);
                } else {
                    dispatch(setQuantNaoLidas(data));
                }
            }

        });

        if (usuario &&
            (usuario.perfil === ADMIN || usuario.perfil === COORDENADOR)) {


            // getQuantAprovacaoComunicado().then((data) => {
            //     if (data) {
            //         if (data.error) {
            //             console.log(data.message);

            //         } else {
            //             dispatch(setQuantAprovacaoComunicado(data));
            //         }
            //     }


            // })

            // getQuantAprovacaoEvento().then((data) => {
            //     if (data) {
            //         if (data.error) {
            //             console.log(data.message);

            //         } else {
            //             dispatch(setQuantAprovacaoEvento(data));
            //         }
            //     }


            // })
        }
    }, [dispatch, usuario, listaAR])

    // useEffect(() => {
    //     const findQuantNaoLidas = setInterval(() => {
    //         getQuantNaoLidas().then((data) => {
    //             if (data) {
    //                 if (data.error) {
    //                     console.log(data.message);
    //                 } else {
    //                     dispatch(setQuantNaoLidas(data));
    //                 }
    //             }
    //         });
    //     }, 10000);
    //     return () => clearInterval(findQuantNaoLidas);
    // }, [dispatch]);

    useEffect(() => {
        if (isLogout) {
            setModal({
                open: true,
                title: 'Acesso Token Expirado.',
                description: 'Seu token de acesso foi expirado. Realizar novamente o login.'
            });
            setTimeout(() => {
                setAnchorEl(null);
                localStorage.removeItem('token');
                dispatch(removeUser());
                setRedirect(true);
            }, 3000);
        }

    }, [isLogout, dispatch])

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClickAR = event => {
        if (usuario.perfil === RESPONSAVEL) {
            setAnchorElAR(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCloseAR = () => {
        setAnchorElAR(null);
    };

    const handleLogout = async () => {
        setAnchorEl(null);
        localStorage.removeItem('token');
        dispatch(removeUser());
        setRedirect(true);
        await persistor.purge().then((data) => console.log(data));
    };

    const handleAtivarAR = (ar) => {
        changeARAluno(ar.aluno).then((data) => {
            if (data.error) {
                errorMessage(data.message)

            } else {
                dispatch(setUsuario(data));
                toast.success("Aluno Selecionado.", {
                    position: "bottom-left"
                });
                handleCloseAR();
            }
        });
    }

    const handleChangeImage = e => {

        const file = e.target.files[0];

        if (file === null) {
            return;
        }

        const fileFormData = new FormData();
        fileFormData.append('file', file);

        changePhoto(usuario.id, fileFormData).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                dispatch(setUsuario(data));
            }
        })




    };

    const handleAttachFile = () => {
        hiddenFileInput.current.click();
    }


    if (redirect) {
        return <Navigate to='/' />
    } else {
        return (
            <>
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline />
                    <SimpleModal modal={modal} setModal={setModal} />
                    <AppBar
                        style={{
                            backgroundColor: usuario && usuario.instituicao && usuario.instituicao.corPrimaria ? usuario.instituicao.corPrimaria : null
                        }}
                        position="fixed" open={open}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                sx={[
                                    {
                                        mr: 2,
                                    },
                                    open && { display: 'none' },
                                ]}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography
                                variant="h6"
                                style={{
                                    color: usuario && usuario.instituicao && usuario.instituicao.corSecundaria ? usuario.instituicao.corSecundaria : null
                                }}
                                noWrap
                                align="center"
                            >
                                {usuario && usuario.instituicao ? usuario.instituicao.descricao + ' -' : ''} {session.getAnoLetivo()}
                            </Typography>
                            <Spacer /> {/* This spacer fills the space */}

                            <Button color="secondary" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClickAR}>
                                <img
                                    style={{
                                        width: '40px',
                                        borderRadius: '20px',
                                    }}
                                    src={usuario && usuario.alunoFoto ?
                                        usuario.alunoFoto.foto : null}
                                    alt=''
                                />
                            </Button>

                            <Button
                                style={{
                                    '@media print': {
                                        display: 'none'
                                    }
                                }}
                                color="secondary"
                                aria-controls="simple-menu"
                                aria-haspopup="true"
                                onClick={handleClick}
                            >
                                {usuario && usuario.fileName ?
                                    <img
                                        src={usuario.fotoUrl}
                                        alt=''
                                        style={{
                                            width: '40px',
                                            borderRadius: '20px',
                                        }}
                                    /> :
                                    <AccountCircle style={{ fontSize: 50, color: 'white' }} />
                                }

                            </Button>
                            <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem
                                    style={{ justifyContent: 'center' }}
                                    onClick={handleAttachFile}
                                >
                                    <input
                                        type="file"
                                        accept=".jpg,.jpeg,.png"
                                        style={{ display: 'none' }}
                                        ref={hiddenFileInput}
                                        onChange={handleChangeImage}
                                    />
                                    {usuario && usuario.fileName ?
                                        <img
                                            src={usuario.fotoUrl}
                                            alt=''
                                            style={{
                                                width: '80px',
                                                borderRadius: '60px',
                                            }}
                                        /> :
                                        <AccountCircle style={{ fontSize: 50, color: 'black' }} />
                                    }
                                </MenuItem>
                                <MenuItem>
                                    {usuario && usuario.email ? usuario.email : ''}
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to={{
                                        pathname: '/usuario-senha',

                                    }}
                                    state={{
                                        usuario: usuario
                                    }}
                                >
                                    <VpnKeyIcon style={{ marginRight: '5px', }} />Trocar Senha
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to={{
                                        pathname: '/configuracao'
                                    }}
                                >
                                    <SettingsIcon style={{ marginRight: '5px', }} />Configuração
                                </MenuItem>

                                <MenuItem onClick={handleLogout}>
                                    <MeetingRoomIcon style={{ marginRight: '5px', }} />Logout
                                </MenuItem>




                            </Menu>
                            <Menu
                                id="simple-menu"
                                anchorEl={anchorElAR}
                                keepMounted
                                open={Boolean(anchorElAR)}
                                onClose={handleCloseAR}
                            >
                                {listaAR.map((ar) => (
                                    <MenuItem
                                        key={ar.codigo}
                                        onClick={() => handleAtivarAR(ar)}
                                    >
                                        <img
                                            style={{
                                                width: '80px',
                                                borderRadius: '20px',
                                                marginRight: '10px'
                                            }}
                                            src={ar.alunoFoto ? ar.alunoFoto.foto : null}
                                            alt=''
                                        />
                                        {ar.aluno.nome}
                                    </MenuItem>
                                ))}

                            </Menu>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        sx={{
                            width: drawerWidth,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: drawerWidth,
                                boxSizing: 'border-box',
                            },
                        }}
                        variant="persistent"
                        anchor="left"
                        open={open}
                    >
                        <DrawerHeader>
                            <Link to='/home'>
                                <img
                                    src={usuario && usuario.instituicao ? usuario.instituicao.urlLogo : ''}
                                    style={{
                                        marginTop: '10px',
                                        marginRight: '30px',
                                        width: drawerWidth - 120,
                                    }}
                                    alt=''
                                />
                            </Link>
                            <IconButton onClick={handleDrawerClose}>
                                {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                            </IconButton>
                        </DrawerHeader>

                        <Divider />
                        <List>

                            {usuario ? LateralMenuList.map((lateralMenu, index) => {
                                const access = lateralMenu.access.find(lm => lm === usuario.perfil);
                                if (access) {
                                    if (lateralMenu.descricao === 'Livro' && !usuario.instituicao.livroHabilitado) {
                                        return ''
                                    }
                                    if (lateralMenu.descricao === 'Avaliação' && !usuario.instituicao.avaliacaoHabilitado) {
                                        return ''
                                    }
                                    if (lateralMenu.descricao === 'Comunicado' &&
                                        usuario.instituicao.comunicadoAprovacao &&
                                        (usuario.perfil === ADMIN || usuario.perfil === COORDENADOR)) {
                                        return (
                                            <ListItem disablePadding key={index}>
                                                <ListItemButton component={Link} to={lateralMenu.link}>
                                                    <ListItemText primary={lateralMenu.descricao} />
                                                    < BadgeQuantNaoLidas quantNaoLidas={quantAprovacaoComunicado} />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    }
                                    if (lateralMenu.descricao === 'Evento' &&
                                        (usuario.perfil === ADMIN || usuario.perfil === COORDENADOR)) {
                                        return (
                                            <ListItem disablePadding key={index}>
                                                <ListItemButton component={Link} to={lateralMenu.link}>
                                                    <ListItemText primary={lateralMenu.descricao} />
                                                    < BadgeQuantNaoLidas quantNaoLidas={quantAprovacaoEvento} />
                                                </ListItemButton>

                                            </ListItem>
                                        )
                                    }
                                    if (lateralMenu.descricao === 'Mensagem') {
                                        if (!usuario.instituicao.mensagemHabilitado) {
                                            return '';
                                        }
                                        else {
                                            return (
                                                <ListItem disablePadding key={index}>
                                                    <ListItemButton component={Link} to={lateralMenu.link}>
                                                        <ListItemText primary={lateralMenu.descricao} />
                                                        <BadgeQuantNaoLidas quantNaoLidas={quantNaoLidas} />
                                                    </ListItemButton>
                                                </ListItem>
                                            )
                                        }

                                    }
                                    if (lateralMenu.descricao === 'Mural' && !usuario.instituicao.muralHabilitado) {
                                        return '';
                                    }
                                    return (
                                        <ListItem key={index} disablePadding>
                                            <ListItemButton component={Link} to={lateralMenu.link}>
                                                <ListItemText primary={lateralMenu.descricao} />
                                            </ListItemButton>
                                        </ListItem>
                                    )


                                } else {
                                    return '';
                                }
                            }) : ''}
                        </List>

                    </Drawer>
                    <Main open={open}>
                        <DrawerHeader />
                        {children}
                    </Main>
                </Box>


            </>


        );
    }


}